export const ComparisonOperatorMap = {
    contains: 'CONTAINS',
    equals: 'EQUALS',
    startsWith: 'STARTS_WITH',
    endsWith: 'ENDS_WITH',
    isEmpty: 'IS_EMPTY',
    isNotEmpty: 'IS_NOT_EMPTY',
    isAnyOf: 'IS_ANY_OF',
    is: 'IS',
    not: 'IS_NOT',
    after: 'IS_AFTER',
    onOrAfter: 'IS_ON_OR_AFTER',
    before: 'IS_BEFORE',
    onOrBefore: 'IS_ON_OR_BEFORE'
}